import IconWithSideMenu from './icon-wtih-dropdown';

export default IconWithSideMenu;